import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { SiteHeader } from './components/SiteHeader';
import { ContactFooter } from './components/ContactFooter';
import { Home } from './pages/Home';
import { IndustryDetail } from './pages/IndustryDetail';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3fa89pae26y7h">
      <div className="w-full min-h-full bg-paper font-sans text-ink antialiased" data-id="element-1" data-mp="3fbt2augtc72p">
        <SiteHeader data-id="element-2" data-mp="2rlyreig20sl3" />
        <Routes data-id="element-3" data-mp="2rlf74v2xls3w">
          <Route path="/" element={<Home data-id="element-5" data-mp="2mluboumz01vx" />} data-id="element-4" data-mp="2rit2b37fdqpd" />
          <Route path="/experience/:slug" element={<IndustryDetail data-id="element-7" data-mp="2mnnh66lukg2c" />} data-id="element-6" data-mp="2mmlt91jqfz37" />
          <Route path="*" element={<Home data-id="element-9" data-mp="31b8fzobovt4g" />} data-id="element-8" data-mp="31aqfuglwour9" />
        </Routes>
        <ContactFooter data-id="element-10" data-mp="31c9ygdv1bhw7" />
      </div>
    </BrowserRouter>;
}